import { HTMLAttributes } from 'react';
import clsx from 'clsx';
import { Icon } from 'components/Icon';
import styles from './VisualHeaderLayout.module.scss';
import { createLayout } from '@clover-util/layout';

type VisualHeaderLayoutProps = HTMLAttributes<HTMLElement> & {
  iconName?: string
  iconSize?: number
}

export const VisualHeaderLayout = createLayout<
VisualHeaderLayoutProps,
  'Visual' | 'Title' | 'Subtitle'
>(function VisualHeaderLayout({ className, iconName, iconSize, ...props }, useRegionRef) {

  return (
    <header
      className={clsx(styles.header, className)}
      {...props}
    >
      <div ref={useRegionRef('Visual')} className={styles.visual}>
      {iconName && iconSize &&
        <Icon className={styles.className} name={iconName} size={iconSize} />
      }
      </div>
      <div ref={useRegionRef('Title')} />
      <div ref={useRegionRef('Subtitle')} className={styles.subtitle} />
    </header>
  );
});
